import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private localeSubject = new BehaviorSubject<string>('');
    public locale$ = this.localeSubject.asObservable();

    constructor(
        @Inject(LOCALE_ID) private localeId: string,
        private translate: TranslateService
    ) {
        // 初始化时设置当前区域设置
        this.localeSubject.next(localeId);
    }

    /**
     * 切换语言并更新区域设置
     * @param langCode 语言代码
     */
    changeLanguage(langCode: string): void {
        // 使用TranslateService切换语言
        this.translate.use(langCode);

        // 更新区域设置
        this.localeSubject.next(langCode);

        // 保存语言设置到本地存储
        localStorage.setItem('selectedLanguage', langCode);

        // 刷新页面以应用新的LOCALE_ID
        // 注意：这是一种简单但有效的方法来更新LOCALE_ID
        // 在生产环境中，可能需要考虑更优雅的方式
        window.location.reload();
    }

    /**
     * 获取当前语言
     */
    getCurrentLanguage(): string {
        return this.translate.currentLang || localStorage.getItem('selectedLanguage') || this.localeId;
    }
}